import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    scrollTop:
      'group hover:border-brand-400 bg-bg-items-black pointer-events-none fixed right-[16px] bottom-[135px] z-100 flex h-[48px] w-[48px] items-center justify-center rounded-[100%] border border-white opacity-0 transition hover:cursor-pointer lg:bottom-[16px]',
    scrollTopIcon:
      'group-hover:[&>path]:stroke-brand-400 rotate-[-90deg] [&>path]:stroke-white',
    scrollTopShowAnimation: 'pointer-events-auto! opacity-100'
  }
});
